import React, { useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from '@reach/router'

import { AuthContext } from '../../../context/authProvider'
import useFeatures from '../../../hooks/useFeatures'
import { useGroowthbookLocaleFeature } from '../../../hooks/useGrowthbook'

import { NavLink } from '../navLink'
import { If } from '../../atoms/if'
import { Image } from '../../atoms/image'
import { SwipeDetector } from '../../atoms/swipeDetector'
import { SuspensfulComponent } from '../../atoms/suspensfulComponent'

import {
  StyledRow,
  StyledCol,
  StyledMenuItemsWrapper,
  StyledContentAnimationWrapper,
  StyledBackgroundAnimationWrapper,
} from './styles'
import { navigate } from 'gatsby'

const locale = process.env.GATSBY_INTL_LOCALE

const SideMenu = (props) => {
  const location = useLocation()
  const { isLoggedIn } = useContext(AuthContext)
  const isCashbackEnabled = useFeatures('cashback')
  const isReferAFriendEnabled = useGroowthbookLocaleFeature(
    'fe_igp_refer_a_friend'
  )
  const { isShown, menu, setSideMenuOpen } = props

  useEffect(() => setSideMenuOpen(false), [location, setSideMenuOpen])

  const handleCashbackNavigation = () => {
    navigate('/cashback')
  }

  return (
    <SwipeDetector onSwipeLeft={() => setSideMenuOpen(false)}>
      <StyledBackgroundAnimationWrapper
        isShown={isShown}
        onClick={() => setSideMenuOpen(false)}
      >
        <StyledContentAnimationWrapper isShown={isShown}>
          <SuspensfulComponent componentName="SideMenuAccount" />

          <StyledMenuItemsWrapper>
            <If
              condition={!isLoggedIn}
              render={() => (
                <>
                  <Image
                    menuItem={menu.filter((m) => m.className === 'logo')[0]}
                  />
                  <StyledRow>
                    {menu
                      .filter((m) => m.className.indexOf('cta mobile') >= 0)
                      .map((item, i) => (
                        <NavLink
                          locale={locale}
                          key={i}
                          menuItem={item}
                          idSuffix="-sideMenu"
                        />
                      ))}
                  </StyledRow>
                </>
              )}
            />

            <StyledCol>
              {menu
                .filter(
                  (m) =>
                    (m.type.toLowerCase() === 'text' &&
                      m.className.indexOf('cta') < 0 &&
                      (m.className !== 'refer-friend' ||
                        isReferAFriendEnabled)) ||
                    (m.name.toLowerCase() === 'cashback' &&
                      isCashbackEnabled) ||
                    m.name.toLowerCase() === 'contact us'
                )
                .map((menuItem, index) => {
                  return (
                    <NavLink
                      locale={locale}
                      key={index}
                      menuItem={menuItem}
                      idSuffix="-sideMenu"
                      action={
                        menuItem?.name?.toLowerCase() === 'cashback'
                          ? handleCashbackNavigation
                          : null
                      }
                    />
                  )
                })}
            </StyledCol>
          </StyledMenuItemsWrapper>
        </StyledContentAnimationWrapper>
      </StyledBackgroundAnimationWrapper>
    </SwipeDetector>
  )
}

SideMenu.defaultProps = {
  isShown: false,
  menu: [],
  setSideMenuOpen: () => {},
}

SideMenu.propTypes = {
  isShown: PropTypes.bool,
  menu: PropTypes.array,
  setSideMenuOpen: PropTypes.func,
}

export { SideMenu }
